import Page from '@/components/pages/newsletter/daily/NewsletterDailyPageController';
import getStaticPaths from '@/components/pages/newsletter/daily/NewsletterDailyPageStaticPaths';
import getStaticProps from '@/components/pages/newsletter/daily/NewsletterDailyPageStaticProps';

export default Page;
export { getStaticProps, getStaticPaths };
